import { Paragraph } from "@sb1/ffe-core-react";
import Link from "./Link";

const FinansPortalenLink = () => {
	return (
		<Paragraph>
			Sammenlign våre priser med andre konkurrenter på&nbsp;
			<Link to="https://www.finansportalen.no/">www.Finansportalen.no</Link>
		</Paragraph>
	);
};

export default FinansPortalenLink;
